<template>
  <div class="concept tutoriel">

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">

          <title-page attrpage="" baseline=""></title-page>

          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  <p>Bonjour, je suis <strong>Globulo</strong> !</p>
                  <p>J'ai le plaisir de vous présenter cette nouvelle plateforme. Vous faites partie des premières personnes à découvrir cet univers</p>
                  <p><strong>Voici quelques conseils</strong> pour vous et nous aider dans cette phase de test...</p>
                </slide>
                <slide>
                  <p>Le site <strong>Globulo Quest</strong> est en cours de construction, mes équipes ont travaillé dur pour la mise en place de cette première version.
                  </br>Toutefois, il est possible que vous rencontriez des erreurs (<em>affichage ou fonctionnalités</em>) lors de votre expérience.</p>
                  <p>Afin de nous aider à faire remonter vos remarques et idées, nous vous proposons un outil...</p>
                </slide>
                <slide>
                  <p>Durant votre visite, vous trouverez en bas à droite de l'écran, <strong>un bouton</strong>, qui permet de <strong>nous laisser un message</strong> sur n'importe quelle page du site si vous rencontrez un problème, une erreur ou simplement si vous souhaitez nous faire part d'une idée.</p>
                  <div class="center"><img src="@/assets/images/content/bt-suggestion.jpg" alt="bouton suggestion" title="bouton suggestion"/></div>
                </slide>
                <slide>
                  <p>Vous avez désormais toutes les cartes en mains pour découvrir cette nouvelle plateforme !</p>
                  <p>Toute mon équipe et moi-même vous remercions d'avance !</p>
                  <p><em>Globulo</em></p>
                </slide>
              </carousel>
            </div>
            <img class="img_mascotte" src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import { Carousel, Slide } from 'vue-carousel'
  export default {
    components: { TitlePage, Carousel, Slide },
  }
</script>
